<lv-instana *ngIf="isRuntimeContextCms()" [instanaUrl]="getInstanaUrl()"></lv-instana>
<ng-container *ngIf="!initial_onChanges && settings$ | async as settings">
  <lv-antragsannahme class="lv-antragsannahme" #antragsannahme *ngIf="settings.environment"></lv-antragsannahme>
</ng-container>
